import { Component } from '@angular/core'
import { tap } from 'rxjs/operators'
import { MbCheckoutStepService } from '../../services/mb-checkout-step.service'

@Component({
  selector: 'mb-checkout-progress',
  templateUrl: './mb-checkout-progress.component.html',
  styleUrls: ['./mb-checkout-progress.component.scss'],
})
export class MbCheckoutProgressComponent {

  activeStepIndex = 0
  steps$ = this.mbCheckoutStepService.steps$
  activeStepIndex$ = this.mbCheckoutStepService.activeStepIndex$.pipe(
    tap(index => this.activeStepIndex = index || 0)
  )

  constructor (protected mbCheckoutStepService: MbCheckoutStepService) {
  }

  getTabIndex (stepIndex: number) {
    return !this.isActive(stepIndex) && !this.isDisabled(stepIndex) ? 0 : -1
  }

  isActive (index: number) {
    return index === this.activeStepIndex
  }

  isDisabled (index: number) {
    return index > this.activeStepIndex
  }
}
